export default __webpack_public_path__ + "static/media/gyroscopesensor.4349a428.png";